// TEMPORARY WORKAROUND — Empire's native ProductDetails.js expects a
// [data-price] attribute that Bold Custom Pricing's markup no longer has,
// so live variant-change price updates silently fail to reach Bold's
// discount-aware pricing. This re-emits Bold's own 'variant_changed' event
// with the correct variant object, letting Bold recalculate and redraw the
// price itself (customer-tier discounts included) instead of us guessing at
// the price value. Remove once migrated off Bold Custom Pricing onto
// Shopify B2B native pricing.
(function () {
  function attachListener() {
    var el = document.querySelector('[data-variant-selection]');
    if (!el || !window.BOLD || !window.BOLD.pre || !window.BOLD.pre.events) return;

    el.addEventListener('variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      window.BOLD.pre.events.emit('variant_changed', { variant: variant });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListener);
  } else {
    attachListener();
  }
})();